import { render, staticRenderFns } from "./g-inline-editor.vue?vue&type=template&id=53ca33e6"
import script from "./g-inline-editor.vue?vue&type=script&lang=js"
export * from "./g-inline-editor.vue?vue&type=script&lang=js"
import style0 from "./g-inline-editor.vue?vue&type=style&index=0&id=53ca33e6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports